//Errors
export const showWhitelistErrorModal = (source) => ({ type: 'SHOW_WHITELIST_ERROR_MODAL',source})


//Sections

export const showNewSectionModal = () => ({ type: 'SHOW_NEW_SECTION_MODAL'})

export const showSectionSelectionModal = (item) => ({ type: 'SHOW_SECTION_SELECTION_MODAL',item})

export const showEditStudentModal= (student,section) => ({ type: 'SHOW_EDIT_STUDENT_MODAL',student,section})

export const showBulkAddStudentsModal= (section,availableCards) => ({ type: 'SHOW_BULK_ADD_STUDENTS_MODAL',section,availableCards})

export const showConfirmEditStudentCardModal = (selectedOption,student) => ({ type: 'CONFIRM_EDIT_STUDENT_CARD_MODAL',selectedOption,student})

export const showManageSectionsModal = () => ({ type: 'SHOW_MANAGE_SECTIONS_MODAL'})

//Set/Question Editor

export const showImageSearchModal= () => ({ type: 'SHOW_IMAGE_SEARCH_MODAL'})

export const saveImageSearchModalImage= (image,thumbnail) => ({ type: 'SAVE_IMAGE',image,thumbnail})

export const finishImageUpload= () => ({ type: 'FINISH_IMAGE_UPLOAD'})

export const showGifSearchModal= () => ({ type: 'SHOW_GIF_SEARCH_MODAL'})

//export const showEquationEditorModal= (latex) => ({ type: 'SHOW_EQUATION_EDITOR_SEARCH_MODAL',latex})

//Misc

export const showConfirmModal = (confirmItem, accept,actionType) => ({ type: 'SHOW_CONFIRM_MODAL', confirmItem, accept,actionType})

export const showLiveViewAlertModal = () => ({ type: 'SHOW_LIVE_VIEW_ALERT_MODAL'})

export const showAddToQueueFromLibraryModal = (sectionId) => ({ type: 'SHOW_ADD_TO_QUEUE_FROM_LIBRARY_MODAL',sectionId})

export const hideModal = () => ({ type: 'HIDE_MODAL' })

export const showExpandedReviewSlideModal = (poll,processedResponses) => ({ type: 'SHOW_EXPANDED_REVIEW_SLIDE_MODAL',poll,processedResponses})

export const showExpandedQuestionSlideModal = (question) => ({ type: 'SHOW_EXPANDED_QUESTION_SLIDE_MODAL',question})


// export const showKeyboardShortcutsModal = () => ({ type: 'SHOW_KEYBOARD_SHORTCUTS_MODAL'})


//Library
export const showEditFolderModal = (folder,parentFolder,newFolderSucess,repoId) => ({ type: 'SHOW_EDIT_FOLDER_MODAL',folder,parentFolder,newFolderSucess,repoId})

export const showMoveToFolderModal = (items,clearSelected) => ({ type: 'SHOW_MOVE_TO_FOLDER_MODAL',items,clearSelected})

export const showRenameSetModal = (set) => ({ type: 'SHOW_RENAME_SET_MODAL',set})


//Repo
export const showNewRepoModal = () => ({ type: 'SHOW_NEW_REPO_MODAL'})
export const showEditRepoModal = (repo) => ({ type: 'SHOW_EDIT_REPO_MODAL',repo})
export const showRepoSelectionModal = (item,multiSelectItems,navigateToRepo) => ({ type: 'SHOW_REPO_SELECTION_MODAL',item,multiSelectItems,navigateToRepo})

//Account



export const showUpdateNameModal = () => ({ type: 'SHOW_UPDATE_NAME_MODAL'})

export const showUpdateEmailModal = () => ({ type: 'SHOW_UPDATE_EMAIL_MODAL'})

export const showChangePasswordModal = () => ({ type: 'SHOW_CHANGE_PASSWORD_MODAL'})

export const showConfirmUpdateGoogleModal = (googleUser) => ({ type: 'SHOW_CONFIRM_UPDATE_GOOGLE_MODAL',googleUser})





export const showUpdatePaymentInfoModal = () => ({ type: 'SHOW_UPDATE_PAYMENT_INFO_MODAL'})

export const showBillingInfoModal = () => ({ type: 'SHOW_BILLING_INFO_MODAL'})

export const showDowngradePlanModal = () => ({ type: 'SHOW_DOWNGRADE_PLAN_MODAL'})

export const showSwitchPlanModal = () => ({ type: 'SHOW_SWITCH_PLAN_MODAL'})


export const showAccountAuthenticationModal = (googleUser) => ({ type: 'SHOW_ACCOUNT_AUTHENTICATION_MODAL',googleUser})

export const showAddPasswordModal = () => ({ type: 'SHOW_ADD_PASSWORD_MODAL'})


export const showScoreSheetCustomRangeModal = (currentSection) => ({ type: 'SHOW_SCORESHEET_CUSTOM_RANGE_MODAL',currentSection})

export const showUpgradeModal = () => ({ type: 'SHOW_UPGRADE_MODAL'})



// WEBPACK FOOTER //
// ./src/actions/modals.js